import React, { useState } from "react";
import "./styles.scss";
import { DefaultHeading, Header } from "../../components";
import { POSCalendar } from "../../assets/svgs";
import { ROUTES } from "../../constants";
import useNavigateWithQuery from "../../hooks/useNavigateWithQuery";
import { useLocation } from "react-router-dom";
import { getPaymentInfo, getPaymentLabel } from "../../utils";
import { useTranslation } from "react-i18next";

const RepaymentSchedule = () => {
  const navigateWithQuery = useNavigateWithQuery();
  const location = useLocation();
  const { t } = useTranslation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const { payments = [] } = location.state || {};
  const [visibleCount, setVisibleCount] = useState(5);

  // const simulatedToday = new Date("2026-01-01T00:00:00");
  const today = new Date();
  const isOverdue = (paymentDate) => {
    if (!paymentDate) return false;
    const date = new Date(paymentDate);
    return date < today;
  };

  const handleToggle = () => {
    setVisibleCount((prev) => (prev === 5 ? payments.length : 5));
  };

  const visiblePayments = payments.slice(0, visibleCount);

  return (
    <div className="payment-container">
      <div className="header-container">
        <Header
          backEnable
          onClick={() => navigateWithQuery(`/${ROUTES.COMPANY_DETAILS}`)}
        />
      </div>

      <DefaultHeading
        heading="repayment_schedule"
        description="upcoming_payments"
        style={{
          headingFontSize: 32,
          descriptionFontSize: 16,
        }}
      />

      <div className="payments-list">
        {visiblePayments.map((payment, index) => {
          const info = getPaymentInfo(payment?.paymentDate);
          const overdue = isOverdue(payment?.paymentDate);

          return (
            <div
              key={index}
              className={`payment-item ${overdue ? "overdue" : ""}`}
            >
              <div className="date">
                <span className="day">{info?.day}</span>
                <span className="month">{info?.month}</span>
              </div>

              <div className="details">
                <div className="title">
                  {`${getPaymentLabel(payment?.no)} ${t(`${routeName}.payment`)}`}
                </div>
                <div className="amount">
                  <span className="icon-saudi_riyal"></span>
                  {payment?.payment}
                </div>
              </div>

              <div className="due">
                <div className="due-icon">
                  <img
                    src={POSCalendar}
                    alt="calendar"
                    className="due-icon"
                    style={{
                      filter: overdue
                        ? "invert(31%) sepia(100%) saturate(7474%) hue-rotate(358deg) brightness(95%) contrast(115%)"
                        : "none",
                    }}
                  />
                </div>
                <span className="due-text">
                  {overdue ? "Overdue" : info?.statusText}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {payments.length > 5 && (
        <p className="view-more" onClick={handleToggle}>
          {visibleCount === 5
            ? t(`${routeName}.view_more`)
            : t(`${routeName}.view_less`, "View less")}
        </p>
      )}
    </div>
  );
};

export default RepaymentSchedule;
